import React from 'react';

export default (props) => {
  return (
    <g {...props}>
      <path
        d='M50.92501,702.2 L50.92501,702.4 L51.42504,702.4 L51.42504,702.2'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.92503,708.4 L48.52501,708.4 L48.52501,710.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.42502,693.2 L45.42502,692.7 L45.32503,692.7 L45.32503,692.6 L44.82504,692.6 L44.82504,692.7 L44.72501,692.7 L44.72501,693.5001 L44.72501,693.6 L44.82504,693.6 L44.92504,693.6 L44.82504,693.7 L44.72501,693.9 L44.62501,694 L44.62501,694.2 L44.62501,694.4 L44.52501,694.6 L44.52501,694.7 L44.52501,694.8 L44.52501,694.9 L44.52501,695 L44.52501,695.1 L44.52501,695.3 L44.52501,695.4 L44.52501,695.6 L44.52501,695.8 L44.52501,696.1 L44.52501,696.3 L44.52501,696.6 L44.52501,696.9 L44.52501,697.2 L44.52501,697.5 L44.52501,697.9 L44.52501,698.2 L44.52501,698.6 L44.52501,699.0001 L44.52501,699.4 L44.52501,699.8 L44.52501,700.3 L44.52501,700.7 L44.52501,701.2 L44.52501,701.7 L44.52501,702.1 L44.52501,702.6 L44.52501,703.2 L44.52501,703.7 L44.52501,704.2 L44.52501,704.8 L44.52501,705.3 L44.52501,705.9 L44.52501,706.5001 L44.52501,707.0001 L44.52501,707.6 L44.52501,708.2 L44.52501,708.8 L44.52501,709.4 L44.52501,710 L44.52501,710.6 L44.52501,711.2 L44.52501,711.8 L44.52501,712.4 L44.52501,713.0001 L44.52501,713.6 L44.52501,714.2 L44.52501,714.8 L44.52501,715.4 L44.52501,716 L44.52501,716.6 L44.52501,717.2 L44.52501,717.8 L44.52501,718.4 L44.52501,719.0001 L44.52501,719.5001 L44.52501,720.1 L44.52501,720.6 L44.52501,721.1 L44.52501,721.7 L44.52501,722.2 L44.52501,722.7 L44.52501,723.2 L44.52501,723.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.22501,781.8 L43.22501,806.9 L43.42501,806.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.72504,780.5001 L48.72504,775.3 L48.72504,775.2 L48.72504,775.1 L48.72504,775 L48.72504,774.9 L48.82504,774.8 L48.92504,774.8'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.32503,759.5001 L43.02502,759.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.22503,693.1 L45.32503,693.1 L45.32503,693.2 L45.32503,693.1 L45.22503,693.1 L45.12503,693.0001 L45.02504,693.0001 L44.92504,693.1 L44.82504,693.1 L44.82504,693.2 L44.72501,693.2 L44.82504,693.2 L44.82504,693.1 L44.92504,693.1 L45.02504,693.0001 L45.12503,693.0001 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.82504,823.8 L48.72504,823.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.02503,806.9 L49.22503,806.9 L49.22503,781.8'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.42502,692.7 L44.72501,692.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.72503,692.7 L47.12501,692.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.52501,708.4 L44.02502,708.4 L44.02502,710.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.42503,758.6 L42.42503,765.2 L42.52503,765.3 L43.22501,765.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.32503,733.7 L45.42502,733.8 L45.52502,733.9 L45.62502,734.0001 L45.72501,734.1 L45.82501,734.1 L45.92501,734.2 L46.12504,734.2 L46.22504,734.2 L46.42503,734.2 L46.52503,734.2 L46.72503,734.1 L46.82502,734.1 L46.92502,734.0001 L47.02501,733.9 L47.12501,733.8 L47.22501,733.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.22501,693.1 L47.12501,693.2 L47.22501,693.1 L47.325,693.1 L47.325,693.0001 L47.42504,693.0001 L47.52504,693.0001 L47.62503,693.1 L47.72503,693.2 L47.62503,693.1 L47.52504,693.0001 L47.42504,693.0001 L47.325,693.0001 L47.325,693.1 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.32503,762.2 L45.22503,762.3 L45.02504,762.4 L44.92504,762.6 L44.82504,762.7 L44.72501,762.9 L44.62501,763 L44.62501,763.2 L44.62501,763.4 L44.52501,763.6 L44.52501,763.7 L44.52501,763.8 L44.52501,763.9 L44.52501,764 L44.52501,764.1 L44.52501,764.3 L44.52501,764.4 L44.52501,764.6 L44.52501,764.8 L44.52501,765.1 L44.52501,765.3 L44.52501,765.6 L44.52501,765.9 L44.52501,766.2 L44.52501,766.5001 L44.52501,766.9 L44.52501,767.1'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.42503,691 L42.32504,691 L42.22504,691 L42.125,691 L42.02501,691 L41.82501,691 L41.72502,691.1 L41.72502,691.2 L40.92504,696.7 L40.92504,696.8 L40.92504,696.9 L40.92504,697.5'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.92503,767.1 L47.92503,766.9 L47.92503,766.5001 L47.92503,766.2 L47.92503,765.9 L47.92503,765.6 L47.92503,765.3 L47.92503,765.1 L47.92503,764.8 L47.92503,764.6 L47.92503,764.4 L47.92503,764.3 L47.92503,764.1 L47.92503,764 L47.92503,763.9 L47.92503,763.8 L47.92503,763.7 L47.92503,763.6 L47.92503,763.4 L47.92503,763.2 L47.82503,763 L47.82503,762.9 L47.72503,762.7 L47.62503,762.6 L47.42504,762.4 L47.325,762.3 L47.22501,762.2'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M51.52504,702.2 L51.52504,702.9 L51.52504,703 L51.52504,703.1 L50.82502,708.5 L50.72502,708.6 L50.72502,708.7 L50.52503,708.7 L50.42503,708.7 L50.32503,708.7 L50.22504,708.7 L50.12504,708.7 L50.22504,708.7 L50.42503,708.7 L50.72502,708.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.82503,723 L43.62504,722.9 L43.52504,722.8 L43.42501,722.7 L43.32501,722.6 L43.12502,722.6 L42.92502,722.6 L42.82502,722.6 L42.62503,722.6 L42.52503,722.6 L42.32504,722.7 L42.22504,722.8 L42.125,722.9 L42.02501,723 L41.92501,723.1 L41.82501,723.2 L41.82501,723.3 L41.72502,723.5 L41.72502,723.6 L41.72502,724.4 L41.62502,724.4 L41.42503,724.4 L41.22503,724.4 L41.02504,724.4 L40.92504,724.4 L40.825,724.4 L40.62501,724.4 L40.52501,724.4 L40.42502,724.4 L40.32502,724.4 L40.22502,724.4 L40.12503,724.4 L40.12503,724.5 L40.02503,724.5 L40.02503,724.6 L40.02503,724.7 L40.02503,724.8 L40.02503,724.9 L40.02503,725 L40.02503,725.1 L40.02503,725.3 L40.02503,725.4 L40.02503,725.6 L40.02503,725.8 L40.02503,725.9 L40.02503,726.1 L40.02503,726.4 L40.02503,726.6 L40.02503,726.8 L40.02503,727.0001 L40.02503,728'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.52503,757 L51.62503,757 L51.62503,757.1 L51.62503,757.8 L51.62503,757.9 L51.62503,758 L51.62503,758.2 L51.62503,758.3 L51.62503,758.4 L51.62503,758.6 L51.62503,758.7 L51.62503,758.8 L51.62503,758.9 L51.62503,759 L51.62503,759.1 L51.62503,759.2 L50.52503,759.2'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.32504,757 L41.22503,757 L41.22503,757.1 L41.22503,757.8 L41.22503,757.9 L41.22503,758 L41.22503,758.2 L41.22503,758.3 L41.22503,758.4 L41.22503,758.6 L41.22503,758.7 L41.22503,758.8 L41.22503,758.9 L41.22503,759 L41.22503,759.1 L41.22503,759.2 L42.32504,759.2 L42.32504,759.1 L42.32504,759 L42.32504,758.9 L42.32504,758.8 L42.32504,758.7 L42.32504,758.6 L42.32504,758.4 L42.32504,758.3 L42.32504,758.2 L42.32504,758 L42.32504,757.9 L42.32504,757.8 L42.32504,757.1 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M51.62503,757.5 L51.72503,757.5 L51.92503,757.5 L52.02502,757.6 L52.12502,757.6 L52.22501,757.7 L52.22501,757.8 L52.32501,757.9 L52.32501,758 L52.32501,758.1 L52.32501,758.2 L52.22501,758.3 L52.22501,758.4 L52.12502,758.5 L52.02502,758.6 L51.92503,758.6 L51.72503,758.7 L51.62503,758.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M51.02501,757 L51.12501,752.4 L51.22501,752.3 L51.22501,752.2 L51.22501,752.1 L51.32504,752.1 L51.42504,752 L51.52504,752 L51.62503,752 L51.72503,752 L51.82503,752 L51.92503,752 L51.92503,752.1 L52.02502,752.1 L52.12502,752.2 L52.12502,752.3 L52.12502,752.4 L52.32501,758.1'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.52503,781.8 L50.52503,781.7 L50.52503,781.6 L50.52503,781.5 L50.52503,781.4 L50.52503,781.3 L50.52503,781.2 L50.52503,781.1 L50.52503,781.0001 L50.02504,781.0001 L50.02504,781.1 L49.92501,781.2 L49.92501,781.3 L49.92501,781.4 L49.82501,781.4 L49.72501,781.4 L49.62502,781.4 L49.52502,781.4 L49.42502,781.4 L49.32502,781.4 L49.32502,781.3 L49.32502,781.2 L49.22503,781.1 L49.22503,781.0001 L48.82504,781.0001 L48.82504,781.1 L48.82504,781.2 L48.82504,781.3 L48.82504,781.4 L48.82504,781.5 L48.82504,781.6 L48.82504,781.7 L48.82504,781.8 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.82504,727.0001 L44.52501,726.8 L44.52501,727.0001 L44.52501,727.3 L44.52501,727.6 L44.52501,727.9 L44.52501,728 L44.52501,726.8 L44.12502,726.5001 L43.72504,726.3 L43.32501,726.0001 L42.92502,725.7 L42.52503,725.4 L42.125,725.1 L42.02501,725 L41.92501,724.9 L41.82501,724.8 L41.82501,724.7 L41.72502,724.5 L41.72502,724.4 L41.72502,724.3 L41.82501,724.1 L41.82501,724 L41.92501,723.9 L42.02501,723.7 L42.125,723.6 L42.22504,723.6 L42.32504,723.5 L42.52503,723.4 L42.62503,723.4 L42.82502,723.4 L42.92502,723.4 L43.12502,723.4 L43.32501,723.4 L43.42501,723.5 L43.52504,723.6 L43.62504,723.7 L43.82503,723.8 L43.82503,723.9 L43.92503,724 L44.12502,724.2 L44.22502,724.3 L44.42501,724.4 L44.62501,724.5 L44.72501,724.6 L44.92504,724.7 L45.12503,724.7 L45.32503,724.8 L45.62502,724.8 L45.82501,724.8 L46.02501,724.8 L46.12504,724.8 L46.22504,724.7 L46.32504,724.7 L46.42503,724.8 L46.52503,724.8 L46.72503,724.8 L46.92502,724.8 L47.12501,724.8 L47.325,724.7 L47.52504,724.7 L47.72503,724.6 L47.92503,724.5 L48.12502,724.4 L48.22502,724.3 L48.42501,724.2 L48.52501,724 L48.62501,723.9 L48.72504,723.8 L48.82504,723.7 L48.92504,723.6 L49.12503,723.5 L49.22503,723.4 L49.42502,723.4 L49.52502,723.4 L49.72501,723.4 L49.82501,723.4 L50.02504,723.4 L50.12504,723.5 L50.32503,723.6 L50.42503,723.6 L50.52503,723.7 L50.62502,723.9 L50.62502,724 L50.72502,724.1 L50.72502,724.3 L50.72502,724.4 L50.72502,724.5 L50.72502,724.7 L50.62502,724.8 L50.62502,724.9 L50.52503,725 L50.32503,725.1 L50.02504,725.4 L49.62502,725.7 L49.22503,726.0001 L48.82504,726.3 L48.42501,726.5001 L48.02502,726.8 L48.02502,728'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.52501,756.6 L44.52501,729.7 L44.52501,729.9 L44.52501,730 L44.52501,730.1 L44.52501,730.2 L44.62501,730.4 L44.62501,730.6 L44.62501,730.8 L44.72501,731 L44.82504,731.1 L44.92504,731 L44.92504,730.8 L45.02504,730.7 L45.12503,730.6 L45.32503,730.5'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.92503,728 L47.92503,726.8'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.92503,723.7 L47.92503,723.2 L47.92503,722.7 L47.92503,722.2 L47.92503,721.7 L47.92503,721.1 L47.92503,720.6 L47.92503,720.1 L47.92503,719.5001 L47.92503,719.0001 L47.92503,718.4 L47.92503,717.8 L47.92503,717.2 L47.92503,716.6 L47.92503,716 L47.92503,715.4 L47.92503,714.8 L47.92503,714.2 L47.92503,713.6 L47.92503,713.0001 L47.92503,712.4 L47.92503,711.8 L47.92503,711.2 L47.92503,710.6 L47.92503,710 L47.92503,709.4 L47.92503,708.8 L47.92503,708.2 L47.92503,707.6 L47.92503,707.0001 L47.92503,706.5001 L47.92503,705.9 L47.92503,705.3 L47.92503,704.8 L47.92503,704.2 L47.92503,703.7 L47.92503,703.2 L47.92503,702.6 L47.92503,702.1 L47.92503,701.7 L47.92503,701.2 L47.92503,700.7 L47.92503,700.3 L47.92503,699.8 L47.92503,699.4 L47.92503,699.0001 L47.92503,698.6 L47.92503,698.2 L47.92503,697.9 L47.92503,697.5 L47.92503,697.2 L47.92503,696.9 L47.92503,696.6 L47.92503,696.3 L47.92503,696.1 L47.92503,695.8 L47.92503,695.6 L47.92503,695.4 L47.92503,695.3 L47.92503,695.1 L47.92503,695 L47.92503,694.9 L47.92503,694.8 L47.92503,694.7 L47.92503,694.6 L47.92503,694.4 L47.92503,694.2 L47.82503,694 L47.82503,693.9 L47.72503,693.7 L47.62503,693.6 L47.42504,693.4 L47.325,693.3 L47.12501,693.2 L47.02501,693.1 L46.82502,693.0001 L46.62503,693.0001 L46.42503,692.9 L46.22504,692.9 L46.02501,692.9 L45.92501,693.0001 L45.72501,693.0001 L45.52502,693.1 L45.32503,693.2 L45.22503,693.3 L45.02504,693.4 L44.92504,693.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.12504,691 L50.22504,691 L50.32503,691 L50.42503,691 L50.52503,691 L50.72502,691 L50.72502,691.1 L50.82502,691.2 L51.52504,696.7 L51.52504,696.8 L51.52504,696.9 L51.52504,697.5'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M25.72503,728.2 L34.02501,728.2 L34.12501,728.2 L34.32504,728.2 L34.52504,728.2 L34.72503,728.2 L34.92503,728.2 L35.02502,728.3 L35.22502,728.3 L35.32501,728.3 L35.52501,728.4 L35.62504,728.4 L35.72504,728.4 L35.72504,728.5 L35.82504,728.5 L35.92503,728.6 L36.12503,728.8 L36.32502,728.9 L36.52502,729 L36.72501,729.1 L36.92504,729.2 L37.12504,729.3 L37.42503,729.4 L37.62502,729.4 L37.92501,729.5 L38.22504,729.5 L38.42504,729.6 L38.72503,729.6 L39.02502,729.7 L39.32501,729.7 L39.62504,729.7 L39.92503,729.7 L40.22502,729.7 L45.52502,729.7 L45.62502,729.7 L45.72501,729.7 L45.82501,729.6 L45.82501,729.5 L45.92501,729.5 L46.02501,729.6 L46.12504,729.6 L46.22504,729.6 L46.32504,729.6 L46.42503,729.6 L46.52503,729.5 L46.62503,729.5 L46.62503,729.6 L46.72503,729.6 L46.82502,729.7 L46.92502,729.7 L52.22501,729.7 L52.42501,729.7 L52.72504,729.7 L53.02503,729.7 L53.32502,729.7 L53.52502,729.7 L53.82501,729.6 L54.12504,729.6 L54.42503,729.5 L54.62502,729.5 L54.92501,729.4 L55.12501,729.3 L55.42504,729.3 L55.62503,729.2 L55.82502,729.1 L56.02502,729 L56.22501,728.9 L56.42501,728.7 L56.62504,728.6 L56.62504,728.5 L56.72504,728.5 L56.82504,728.5 L56.92503,728.4 L57.02503,728.4 L57.12503,728.3 L57.22502,728.3 L57.42501,728.3 L57.52501,728.2 L57.72501,728.2 L57.92504,728.2 L58.12503,728.2 L58.32503,728.2 L58.52502,728.2 L66.72501,728.2'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.125,712 L40.62501,712 L40.62501,712.1 L40.62501,712.2 L40.62501,712.3 L40.62501,712.4 L40.62501,712.5001 L40.62501,712.6 L40.62501,712.7 L40.62501,712.8 L40.62501,712.9 L41.92501,712.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.42503,712 L51.82503,712 L51.82503,712.1 L51.82503,712.2 L51.82503,712.3 L51.82503,712.4 L51.82503,712.5001 L51.82503,712.6 L51.82503,712.7 L51.82503,712.8 L51.82503,712.9 L50.52503,712.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M66.72501,726.5001 L58.52502,726.5001 L58.42503,726.5001 L58.12503,726.5001 L57.92504,726.5001 L57.62501,726.5001 L57.42501,726.6 L57.22502,726.6 L56.92503,726.7 L56.72504,726.7 L56.52504,726.8 L56.32501,726.8 L56.12502,726.9 L55.92502,727.0001 L55.72503,727.1 L55.52503,727.2 L55.42504,727.3 L55.42504,727.4 L55.32504,727.4 L55.22504,727.5 L55.12501,727.5 L55.02501,727.6 L54.92501,727.6 L54.72502,727.7 L54.62502,727.8 L54.42503,727.8 L54.22503,727.8 L54.02504,727.9 L53.82501,727.9 L53.52502,728 L53.32502,728 L53.12503,728 L52.82504,728 L52.62504,728 L52.32501,728 L52.22501,728 L40.22502,728 L40.12503,728 L39.82504,728 L39.62504,728 L39.32501,728 L39.12502,728 L38.92502,728 L38.62503,727.9 L38.42504,727.9 L38.22504,727.8 L38.02501,727.8 L37.82502,727.7 L37.72502,727.7 L37.52502,727.6 L37.42503,727.6 L37.32503,727.5 L37.22503,727.5 L37.12504,727.4 L37.02504,727.3 L36.82501,727.2 L36.72501,727.1 L36.52502,727.0001 L36.32502,726.9 L36.12503,726.8 L35.92503,726.7 L35.62504,726.7 L35.42501,726.6 L35.22502,726.6 L34.92503,726.5001 L34.72503,726.5001 L34.42504,726.5001 L34.22501,726.5001 L34.02501,726.5001 L25.72503,726.5001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.02501,781.8 L43.72504,781.8 L43.72504,781.7 L43.72504,781.6 L43.72504,781.5 L43.72504,781.4 L43.72504,781.3 L43.72504,781.2 L43.72504,781.1 L43.72504,781.0001 L43.32501,781.0001 L43.22501,781.1 L43.22501,781.2 L43.22501,781.3 L43.22501,781.4 L43.12502,781.4 L43.02502,781.4 L42.92502,781.4 L42.82502,781.4 L42.72503,781.4 L42.62503,781.4 L42.52503,781.4 L42.52503,781.3 L42.52503,781.2 L42.52503,781.1 L42.52503,781.0001 L42.02501,781.0001 L42.02501,781.1 L42.02501,781.2 L42.02501,781.3 L42.02501,781.4 L42.02501,781.5 L42.02501,781.6 L42.02501,781.7 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.72503,693.5001 L47.62503,693.6 L47.72503,693.6 L47.72503,693.5001 L47.72503,692.7 L47.72503,692.6 L47.22501,692.6 L47.12501,692.6 L47.12501,692.7 L47.12501,693.2 L47.22501,693.1 L47.325,693.1 L47.325,693.0001 L47.42504,693.0001 L47.52504,693.0001 L47.62503,693.1 L47.72503,693.2 L47.62503,693.1 L47.52504,693.0001 L47.42504,693.0001 L47.325,693.0001 L47.325,693.1 L47.22501,693.1 L47.12501,693.2'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.42502,759.6 L47.22501,759.5001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.62502,756.4 L49.42502,756.4 L49.42502,756.5 L49.42502,756.6 L49.42502,756.7 L49.42502,756.8 L49.42502,756.9 L49.42502,757.1 L49.42502,757.2 L49.42502,757.4 L49.42502,757.5 L49.42502,757.7 L49.42502,757.9 L49.42502,758.1 L49.42502,758.3 L49.42502,758.5 L49.42502,758.6 L49.42502,758.8 L49.42502,759 L49.42502,759.1 L49.42502,759.3 L49.42502,759.4 L49.42502,759.5001 L49.42502,759.6 L49.42502,759.7 L49.62502,759.7 L49.62502,759.6 L49.62502,759.5001 L49.62502,759.4 L49.62502,759.3 L49.62502,759.1 L49.62502,759 L49.62502,758.8 L49.62502,758.6 L49.62502,758.5 L49.62502,758.3 L49.62502,758.1 L49.62502,757.9 L49.62502,757.7 L49.62502,757.5 L49.62502,757.4 L49.62502,757.2 L49.62502,757.1 L49.62502,756.9 L49.62502,756.8 L49.62502,756.7 L49.62502,756.6 L49.62502,756.5 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.22501,761.0001 L48.02502,762.8 L48.12502,762.9 L48.12502,763 L48.22502,763.1 L48.22502,763.3 L48.22502,763.4 L48.32502,763.5 L48.32502,763.6 L48.32502,763.8 L48.52501,768.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.32502,769.6 L49.02503,763.7 L49.02503,763.6 L49.02503,763.4 L49.02503,763.2 L48.92504,763.1 L48.92504,762.9 L48.82504,762.8 L48.82504,762.6 L48.72504,762.5 L47.42504,759.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M51.42504,697.3 L50.92501,697.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.92503,768.6 L44.22502,763.8 L44.22502,763.6 L44.22502,763.5 L44.22502,763.4 L44.32502,763.3 L44.32502,763.1 L44.32502,763 L44.42501,762.9 L44.42501,762.8 L45.32503,761.0001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.12503,759.6 L43.82503,762.5 L43.72504,762.6 L43.62504,762.8 L43.62504,762.9 L43.52504,763.1 L43.52504,763.2 L43.52504,763.4 L43.42501,763.6 L43.42501,763.7 L43.12502,769.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M41.12503,697.3 L41.62502,697.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M40.52501,728 L40.52501,727.0001 L40.52501,726.8 L40.52501,726.6 L40.52501,726.4 L40.52501,726.1 L40.52501,725.9 L40.52501,725.8 L40.52501,725.6 L40.52501,725.4 L40.52501,725.3 L40.52501,725.1 L40.52501,725 L40.52501,724.9 L40.52501,724.8 L40.52501,724.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M40.02503,729.7 L40.02503,734.1 L40.02503,734.3 L40.02503,734.5 L40.02503,734.7 L40.02503,734.9 L40.02503,735.1 L40.02503,735.3 L40.02503,735.5 L40.02503,735.6 L40.02503,735.8 L40.02503,735.9 L40.02503,736 L40.02503,736.1 L40.02503,736.2 L40.02503,736.3 L40.02503,736.4 L40.12503,736.5 L40.22502,736.5 L40.32502,736.5 L40.42502,736.5 L40.42502,736.4'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.42503,736.4 L42.22504,736.4 L42.02501,736.4 L41.82501,736.4 L41.62502,736.4 L41.52502,736.4 L41.32503,736.4 L41.12503,736.4 L41.02504,736.4 L40.825,736.4 L40.72501,736.4 L40.62501,736.4 L40.52501,736.4 L40.42502,736.4 L40.52501,736.4 L40.52501,736.3 L40.52501,736.2 L40.52501,736.1 L40.52501,736 L40.52501,735.9 L40.52501,735.8 L40.52501,735.6 L40.52501,735.5 L40.52501,735.3 L40.52501,735.1 L40.52501,734.9 L40.52501,734.7 L40.52501,734.5 L40.52501,734.3 L40.52501,734.1 L40.52501,729.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.92502,756.4 L42.92502,756.5 L42.92502,756.6 L42.92502,756.7 L42.92502,756.8 L42.92502,756.9 L42.92502,757.1 L42.92502,757.2 L42.92502,757.4 L42.92502,757.5 L42.92502,757.7 L42.92502,757.9 L42.92502,758.1 L42.92502,758.3 L42.92502,758.5 L42.92502,758.6 L42.92502,758.8 L42.92502,759 L42.92502,759.1 L42.92502,759.3 L42.92502,759.4 L42.92502,759.5001 L42.92502,759.6 L42.92502,759.7 L43.02502,759.7 L43.02502,759.6 L43.02502,759.5001 L43.02502,759.4 L43.02502,759.3 L43.02502,759.1 L43.02502,759 L43.02502,758.8 L43.02502,758.6 L43.02502,758.5 L43.02502,758.3 L43.02502,758.1 L43.02502,757.9 L43.02502,757.7 L43.02502,757.5 L43.02502,757.4 L43.02502,757.2 L43.02502,757.1 L43.02502,756.9 L43.02502,756.8 L43.02502,756.7 L43.02502,756.6 L43.02502,756.5 L43.02502,756.4 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M40.52501,724.9 L40.62501,724.9 L40.72501,724.9 L40.825,724.9 L41.02504,724.9 L41.12503,724.9 L41.32503,724.9 L41.52502,724.9 L41.62502,724.9 L41.82501,724.9 L41.92501,724.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.42503,735.9 L42.22504,735.9 L42.125,735.9 L41.92501,735.9 L41.72502,735.9 L41.62502,735.9 L41.42503,735.9 L41.22503,735.9 L41.02504,736 L40.92504,736 L40.825,736 L40.62501,736 L40.52501,736'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M41.02504,702.2 L33.92501,702.2 L33.92501,702.1 L33.92501,702 L33.92501,701.9 L33.92501,701.8 L33.92501,697.9 L33.92501,697.8 L33.92501,697.7 L33.92501,697.6 L33.92501,697.5 L41.72502,697.5 L41.72502,698.2 L41.82501,698.2 L41.82501,701.5 L41.72502,701.5 L41.72502,702.2 L41.62502,702.2 L41.42503,702.2 L41.12503,702.2 L40.92504,702.2 L40.92504,702.9 L40.92504,703 L40.92504,703.1 L41.72502,708.5 L41.72502,708.6 L41.82501,708.7 L42.02501,708.7 L42.125,708.7 L42.22504,708.7 L42.32504,708.7 L42.42503,708.7 L42.32504,708.7 L42.125,708.7 L41.82501,708.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.92504,823.8 L49.02503,823.7 L49.12503,823.6 L49.12503,824.5 L49.12503,824.6 L49.12503,824.7 L49.22503,824.8 L49.22503,824.9 L49.32502,824.9 L49.42502,825 L49.52502,825 L49.62502,825 L50.22504,825 L50.32503,825 L50.52503,825.1 L50.62502,825.1 L50.72502,825.2 L50.82502,825.3 L50.92501,825.4 L51.02501,825.6 L51.12501,825.7 L51.12501,825.8 L51.12501,826 L51.12501,827.1 L51.12501,827.3 L51.12501,827.4 L51.02501,827.5001 L50.92501,827.7 L50.82502,827.8 L50.72502,827.9 L50.62502,827.9 L50.52503,828.0001 L50.32503,828.0001 L50.22504,828.0001 L42.32504,828.0001 L42.125,828.0001 L42.02501,828.0001 L41.92501,827.9 L41.72502,827.9 L41.62502,827.8 L41.52502,827.7 L41.52502,827.5001 L41.42503,827.4 L41.42503,827.3 L41.42503,827.1 L41.42503,826 L41.42503,825.8 L41.42503,825.7 L41.52502,825.6 L41.52502,825.4 L41.62502,825.3 L41.72502,825.2 L41.92501,825.1 L42.02501,825.1 L42.125,825 L42.32504,825 L42.82502,825 L42.92502,825 L43.12502,825 L43.22501,824.9 L43.32501,824.8 L43.42501,824.7 L43.42501,824.6 L43.42501,824.5 L43.42501,823.6 L43.42501,781.8'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.52501,806.9 L44.52501,783.3 L44.02502,783.3 L44.02502,783.2 L44.02502,783.1 L44.02502,783 L44.02502,782.9 L44.02502,782.7 L44.02502,782.6 L44.02502,782.4 L44.02502,782.2 L44.02502,782.1 L44.02502,781.9 L44.02502,781.7 L44.02502,781.5 L44.02502,781.3 L44.02502,781.1 L44.02502,780.9 L44.02502,780.7 L44.02502,780.5001 L44.02502,780.3 L44.02502,780.2 L44.02502,780.0001 L44.02502,779.9 L44.02502,779.8 L44.02502,779.7 L44.02502,779.6 L44.02502,779.5 L44.52501,779.5 L44.52501,772.9 L44.52501,773.2 L44.52501,773.8 L44.52501,774.3 L44.52501,774.9 L44.52501,775.5 L44.52501,776 L44.52501,776.6 L44.52501,777.2 L44.52501,777.8 L44.52501,778.4 L44.52501,779 L44.52501,779.6 L44.52501,780.2 L44.52501,780.8 L44.52501,781.4 L44.52501,782 L44.52501,782.6 L44.52501,783.2 L44.52501,783.8 L44.52501,784.4 L44.52501,785 L44.52501,785.6 L44.52501,786.2 L44.52501,786.8 L44.52501,787.4 L44.52501,788.0001 L44.52501,788.5 L44.52501,789.1 L44.52501,789.6 L44.52501,790.1 L44.52501,790.7 L44.52501,791.2 L44.52501,791.7 L44.52501,792.2 L44.52501,792.7 L44.52501,793.1 L44.52501,793.6 L44.52501,794.0001 L44.52501,794.4 L44.52501,794.8 L44.52501,795.2 L44.52501,795.6 L44.52501,796 L44.52501,796.3 L44.52501,796.6 L44.52501,796.9 L44.52501,797.2 L44.52501,797.5 L44.52501,797.8 L44.52501,798 L44.52501,798.2 L44.52501,798.4 L44.52501,798.6 L44.52501,798.7 L44.52501,798.9 L44.52501,799 L44.52501,799.1 L44.52501,799.2 L44.62501,799.4 L44.62501,799.6 L44.62501,799.8 L44.72501,800.0001 L44.82504,800.1 L44.92504,800.3 L45.02504,800.4 L45.22503,800.6 L45.32503,800.7 L45.52502,800.8 L45.72501,800.8 L45.92501,800.9 L46.02501,800.9 L46.22504,800.9 L46.42503,800.9 L46.62503,800.9 L46.82502,800.8 L47.02501,800.8 L47.12501,800.7 L47.325,800.6 L47.42504,800.4 L47.62503,800.3 L47.72503,800.1 L47.82503,800.0001 L47.82503,799.8 L47.92503,799.6 L47.92503,799.4 L47.92503,799.2 L47.92503,799.1 L47.92503,799 L47.92503,798.9 L47.92503,798.7 L47.92503,798.6 L47.92503,798.4 L47.92503,798.2 L47.92503,798 L47.92503,797.8 L47.92503,797.5 L47.92503,797.2 L47.92503,796.9 L47.92503,796.6 L47.92503,796.3 L47.92503,796 L47.92503,795.6 L47.92503,795.2 L47.92503,794.8 L47.92503,794.4 L47.92503,794.0001 L47.92503,793.6 L47.92503,793.1 L47.92503,792.7 L47.92503,792.2 L47.92503,791.7 L47.92503,791.2 L47.92503,790.7 L47.92503,790.1 L47.92503,789.6 L47.92503,789.1 L47.92503,788.5 L47.92503,788.0001 L47.92503,787.4 L47.92503,786.8 L47.92503,786.2 L47.92503,785.6 L47.92503,785 L47.92503,784.4 L47.92503,783.8 L47.92503,783.2 L47.92503,782.6 L47.92503,782 L47.92503,781.4 L47.92503,780.8 L47.92503,780.2 L47.92503,779.6 L47.92503,779 L47.92503,778.4 L47.92503,777.8 L47.92503,777.2 L47.92503,776.6 L47.92503,776 L47.92503,775.5 L47.92503,774.9 L47.92503,774.3 L47.92503,773.8 L47.92503,773.2 L47.92503,772.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.92503,779.5 L48.52501,779.5 L48.52501,779.6 L48.52501,779.7 L48.52501,779.8 L48.52501,779.9 L48.52501,780.0001 L48.52501,780.2 L48.52501,780.3 L48.52501,780.5001 L48.52501,780.7 L48.52501,780.9 L48.52501,781.1 L48.52501,781.3 L48.52501,781.5 L48.52501,781.7 L48.52501,781.9 L48.52501,782.1 L48.52501,782.2 L48.52501,782.4 L48.52501,782.6 L48.52501,782.7 L48.52501,782.9 L48.52501,783 L48.52501,783.1 L48.52501,783.2 L48.52501,783.3 L47.92503,783.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.52501,708.5 L44.12502,708.5 L44.12502,710.3 L44.12502,710.4 L44.12502,710.5 L44.12502,710.6 L44.12502,710.7 L44.12502,710.9 L44.12502,711 L44.12502,711.2 L44.12502,711.4 L44.12502,711.6 L44.12502,711.8 L44.12502,712 L44.12502,712.2 L44.12502,712.4 L44.12502,712.6 L44.12502,712.8 L44.12502,713.0001 L44.12502,713.2 L44.12502,713.4 L44.12502,713.6 L44.12502,713.8 L44.12502,713.9 L44.12502,714.1 L44.12502,714.2 L44.12502,714.3 L44.12502,714.4 L44.12502,714.5 L44.12502,714.6 L43.92503,714.6 L43.92503,714.5 L43.92503,714.4 L43.92503,714.3 L43.92503,714.2 L43.92503,714.1 L43.92503,713.9 L43.92503,713.8 L43.92503,713.6 L43.92503,713.4 L43.92503,713.2 L43.92503,713.0001 L43.92503,712.8 L43.92503,712.6 L43.92503,712.4 L43.92503,712.2 L43.92503,712 L43.92503,711.8 L43.92503,711.6 L43.92503,711.4 L43.92503,711.2 L43.92503,711 L43.92503,710.9 L43.92503,710.7 L43.92503,710.6 L43.92503,710.5 L43.92503,710.4 L43.92503,710.3 L43.62504,711.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.62504,823.6 L48.82504,823.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.72504,823.7 L43.62504,823.7 L43.52504,823.7 L43.42501,823.7 L43.42501,823.6 L43.52504,823.6 L43.52504,823.7 L43.52504,823.8 L43.62504,823.8 L43.72504,823.8 L43.72504,823.7 L43.82503,823.8 L43.82503,824.5 L43.82503,824.6 L43.72504,824.8 L43.72504,824.9 L43.62504,825 L43.52504,825.1 L43.42501,825.2 L43.32501,825.3 L43.12502,825.4 L43.02502,825.4 L42.82502,825.4 L42.32504,825.4 L42.22504,825.4 L42.125,825.5 L42.02501,825.5 L41.92501,825.6 L41.82501,825.7 L41.82501,825.8 L41.72502,825.9 L41.72502,826 L41.72502,827.1 L41.72502,827.2 L41.82501,827.3 L41.82501,827.4 L41.92501,827.5001 L42.02501,827.6 L42.125,827.6 L42.22504,827.7 L42.32504,827.7 L50.22504,827.7 L50.32503,827.7 L50.42503,827.6 L50.52503,827.6 L50.62502,827.5001 L50.62502,827.4 L50.72502,827.3 L50.72502,827.2 L50.72502,827.1 L50.72502,826 L50.72502,825.9 L50.72502,825.8 L50.62502,825.7 L50.62502,825.6 L50.52503,825.5 L50.42503,825.5 L50.32503,825.4 L50.22504,825.4 L49.62502,825.4 L49.52502,825.4 L49.32502,825.4 L49.22503,825.3 L49.12503,825.2 L49.02503,825.1 L48.92504,825 L48.82504,824.9 L48.72504,824.8 L48.72504,824.6 L48.72504,824.5 L48.72504,823.8 L48.72504,823.7 L48.92504,823.7 L49.02503,823.7 L49.02503,823.6 L49.02503,781.8'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.62504,774.8 L43.72504,774.8 L43.72504,774.9 L43.82503,774.9 L43.82503,775 L43.82503,775.1 L43.82503,775.2 L43.82503,775.3 L43.82503,780.5001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.92503,711.8 L48.22502,711.8 L48.22502,711.9 L48.22502,712 L48.22502,712.1 L48.22502,712.2 L48.22502,712.4 L48.22502,712.5001 L48.22502,712.6 L48.22502,712.7 L48.22502,712.8 L48.22502,712.9 L48.22502,713.0001 L48.22502,713.1 L47.92503,713.1'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.72504,806.9 L43.82503,806.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.92503,708.5 L48.42501,708.5 L48.42501,710.3 L48.42501,710.4 L48.42501,710.5 L48.42501,710.6 L48.42501,710.7 L48.42501,710.9 L48.42501,711 L48.42501,711.2 L48.42501,711.4 L48.42501,711.6 L48.42501,711.8 L48.42501,712 L48.42501,712.2 L48.42501,712.4 L48.42501,712.6 L48.42501,712.8 L48.42501,713.0001 L48.42501,713.2 L48.42501,713.4 L48.42501,713.6 L48.42501,713.8 L48.42501,713.9 L48.42501,714.1 L48.42501,714.2 L48.42501,714.3 L48.42501,714.4 L48.42501,714.5 L48.42501,714.6 L48.62501,714.6 L48.62501,714.5 L48.62501,714.4 L48.62501,714.3 L48.62501,714.2 L48.62501,714.1 L48.62501,713.9 L48.62501,713.8 L48.62501,713.6 L48.62501,713.4 L48.62501,713.2 L48.62501,713.0001 L48.62501,712.8 L48.62501,712.6 L48.62501,712.4 L48.62501,712.2 L48.62501,712 L48.62501,711.8 L48.62501,711.6 L48.62501,711.4 L48.62501,711.2 L48.62501,711 L48.62501,710.9 L48.62501,710.7 L48.62501,710.6 L48.62501,710.5 L48.62501,710.4 L48.62501,710.3 L48.52501,710.3 L48.42501,710.3 L48.42501,710.4'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M46.52503,688.7 L46.42503,688.7 L46.32504,688.7 L46.22504,688.7 L46.12504,688.7 L46.02501,688.7 L46.12504,688.7 L46.22504,688.7 L46.32504,688.7 L46.42503,688.7 L46.52503,688.7 L46.42503,688.7 L46.32504,688.7 L46.22504,688.7 L46.12504,688.7 L46.02501,688.7 L46.12504,688.7 L46.22504,688.7 L46.32504,688.7 L46.42503,688.7 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.52501,711.8 L44.32502,711.8 L44.32502,711.9 L44.32502,712 L44.32502,712.1 L44.32502,712.2 L44.32502,712.4 L44.32502,712.5001 L44.32502,712.6 L44.32502,712.7 L44.32502,712.8 L44.32502,712.9 L44.32502,713.0001 L44.32502,713.1 L44.52501,713.1'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.52503,764.5 L50.52503,764.4 L50.52503,764.3 L50.52503,764.2 L50.52503,764.1 L50.52503,764 L50.52503,763.8 L50.52503,763.6 L50.52503,763.4 L50.52503,763.2 L50.52503,763 L50.52503,762.8 L50.52503,762.5 L50.52503,762.3 L50.52503,762 L50.52503,761.7 L50.52503,761.4 L50.52503,761.1 L50.52503,760.7 L50.52503,760.4 L50.52503,760.1 L50.52503,759.7 L50.52503,759.4 L50.52503,759 L50.52503,758.6 L50.52503,758.3 L50.52503,757.9 L50.52503,757.5 L50.52503,757.2 L50.52503,756.8 L50.52503,756.5 L50.52503,756.1 L50.52503,755.8 L50.52503,755.4 L50.52503,755.1 L50.52503,754.8 L50.52503,754.5 L50.52503,754.2 L50.52503,753.9 L50.52503,753.6 L50.52503,753.4 L50.52503,753.1 L50.52503,752.9 L50.52503,752.7 L50.52503,752.5 L50.52503,752.4 L50.52503,752.2 L50.52503,752.1 L50.52503,752 L50.52503,751.9 L50.52503,751.8 L50.52503,751.7 L50.42503,751.7 L50.42503,751.8 L50.42503,751.9 L50.42503,752 L50.42503,752.1 L50.42503,752.2 L50.42503,752.4 L50.42503,752.5 L50.42503,752.7 L50.42503,752.9 L50.42503,753.1 L50.42503,753.4 L50.42503,753.6 L50.42503,753.9 L50.42503,754.2 L50.42503,754.5 L50.42503,754.8 L50.42503,755.1 L50.42503,755.4 L50.42503,755.8 L50.42503,756.1 L50.42503,756.5 L50.42503,756.8 L50.42503,757.2 L50.42503,757.5 L50.42503,757.9 L50.42503,758.3 L50.42503,758.6 L50.42503,759 L50.42503,759.4 L50.42503,759.7 L50.42503,760.1 L50.42503,760.4 L50.42503,760.7 L50.42503,761.1 L50.42503,761.4 L50.42503,761.7 L50.42503,762 L50.42503,762.3 L50.42503,762.5 L50.42503,762.8 L50.42503,763 L50.42503,763.2 L50.42503,763.4 L50.42503,763.6 L50.42503,763.8 L50.42503,764 L50.42503,764.1 L50.42503,764.2 L50.42503,764.3 L50.42503,764.4 L50.42503,764.5 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.42501,693.0001 L44.42501,692.9 L44.32502,692.9 L44.12502,692.9 L44.32502,692.9 L44.42501,692.9 L44.42501,693.0001 L44.42501,706.7 L44.42501,706.8 L44.42501,706.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.12502,693.0001 L48.12502,692.9 L48.22502,692.9 L48.42501,692.9 L48.22502,692.9 L48.12502,692.9 L48.12502,693.0001 L48.12502,706.7 L48.12502,706.8 L48.12502,706.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.12502,710.4 L43.92503,710.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.52501,714.6 L48.52501,723.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.42501,714.4 L48.42501,716.3 L48.42501,723.4 L48.22502,723.5 L48.12502,723.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.12502,714.4 L44.12502,723.4'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.02502,714.6 L44.02502,723.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.42503,711.7 L42.62503,711.6 L42.72503,711.6 L42.82502,711.6 L43.02502,711.6 L43.12502,711.6 L43.22501,711.7 L43.42501,711.7 L43.52504,711.8 L43.62504,711.9 L43.62504,712 L43.62504,712.2 L43.72504,712.5001 L43.72504,712.6 L43.72504,712.8 L43.82503,712.9 L43.82503,713.0001 L43.82503,713.1 L43.82503,713.2 L43.82503,723 L43.82503,723.1 L43.92503,723.2 L44.12502,723.4 L44.22502,723.5 L44.42501,723.6 L44.62501,723.7 L44.72501,723.8 L44.92504,723.9 L45.12503,723.9 L45.32503,724 L45.62502,724 L45.82501,724 L46.02501,724 L46.12504,724 L46.22504,724 L46.32504,724 L46.42503,724 L46.52503,724 L46.72503,724 L46.92502,724 L47.12501,724 L47.325,723.9 L47.52504,723.9 L47.72503,723.8 L47.92503,723.7 L48.12502,723.6 L48.12502,713.1'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M41.92501,723 L41.92501,712.6 L41.92501,712.5001 L42.02501,712.4 L42.02501,712.2 L42.02501,712.1 L42.02501,712 L42.125,711.9 L42.22504,711.8 L42.32504,711.8 L42.42503,711.7 L42.42503,688.4 L42.52503,688.4 L44.12502,688.4 L48.42501,688.4 L50.02504,688.4 L50.12504,688.4 L50.12504,711.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.52503,723 L50.52503,712.6 L50.52503,712.5001 L50.52503,712.3 L50.52503,712.2 L50.42503,712.1 L50.42503,712 L50.42503,711.9 L50.32503,711.8 L50.22504,711.8 L50.02504,711.7 L49.92501,711.6 L49.82501,711.6 L49.62502,711.6 L49.52502,711.6 L49.42502,711.6 L49.22503,711.7 L49.12503,711.7 L49.02503,711.8 L48.92504,711.9 L48.92504,712.1 L48.82504,712.3 L48.82504,712.5001 L48.82504,712.7 L48.72504,712.8 L48.72504,713.0001 L48.72504,713.1 L48.72504,713.2 L48.72504,723'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M25.82502,726.6 L25.72503,726.6 L25.72503,726.5001 L25.72503,726.6 L25.72503,726.7 L25.72503,726.8 L25.72503,726.9 L25.72503,727.0001 L25.72503,727.1 L25.72503,727.2 L25.72503,727.4 L25.72503,727.5 L25.72503,727.6 L25.72503,727.8 L25.72503,727.9 L25.72503,728 L25.72503,728.1 L25.72503,728.2 L25.82502,728.2 L25.82502,728.1 L25.82502,728 L25.82502,727.9 L25.82502,727.8 L25.82502,727.6 L25.82502,727.5 L25.82502,727.4 L25.82502,727.2 L25.82502,727.1 L25.82502,727.0001 L25.82502,726.9 L25.82502,726.8 L25.82502,726.7 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.42501,723.4 L48.52501,723.2 L48.62501,723.1 L48.72504,723 L48.82504,722.9 L48.92504,722.8 L49.12503,722.7 L49.22503,722.6 L49.42502,722.6 L49.52502,722.6 L49.72501,722.6 L49.82501,722.6 L50.02504,722.6 L50.12504,722.7 L50.32503,722.8 L50.42503,722.9 L50.52503,723 L50.62502,723.1 L50.62502,723.2 L50.72502,723.3 L50.72502,723.5 L50.72502,723.6 L50.72502,724.4'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M66.72501,726.5001 L66.82501,726.6 L66.82501,726.7 L66.82501,726.8 L66.82501,726.9 L66.82501,727.0001 L66.82501,727.1 L66.82501,727.2 L66.82501,727.4 L66.82501,727.5 L66.82501,727.6 L66.82501,727.8 L66.82501,727.9 L66.82501,728 L66.82501,728.1 L66.72501,728.2 L66.72501,728.1 L66.72501,728 L66.72501,727.9 L66.72501,727.8 L66.72501,727.6 L66.72501,727.5 L66.72501,727.4 L66.72501,727.2 L66.72501,727.1 L66.72501,727.0001 L66.72501,726.9 L66.72501,726.8 L66.72501,726.7 L66.72501,726.6 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.22503,726.2 L45.22503,726.0001 L45.22503,725.9 L45.32503,725.8 L45.42502,725.7 L45.52502,725.6 L45.62502,725.5 L45.72501,725.4 L45.82501,725.3 L45.92501,725.3 L46.12504,725.3 L46.22504,725.2 L46.42503,725.3 L46.52503,725.3 L46.72503,725.3 L46.82502,725.4 L46.92502,725.5 L47.02501,725.6 L47.12501,725.7 L47.22501,725.8 L47.22501,725.9 L47.325,726.0001 L47.325,726.2'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.32502,768.3 L44.12502,768.5 L43.92503,768.7 L43.72504,768.9 L43.52504,769.1 L43.32501,769.3 L43.12502,769.5 L43.02502,769.8 L42.92502,770 L42.82502,770.2 L42.72503,770.4 L42.72503,770.6 L42.62503,770.8 L42.62503,771 L42.72503,771.2 L42.72503,771.4 L42.82502,771.6 L42.82502,771.8 L42.92502,772 L43.12502,772.1 L43.22501,772.3 L43.32501,772.4 L43.52504,772.6 L43.72504,772.7 L43.92503,772.7 L44.12502,772.8 L44.32502,772.9 L44.52501,772.9 L44.72501,772.9 L44.92504,772.9 L45.12503,772.8 L45.32503,772.8 L45.52502,772.7 L45.62502,772.6 L45.82501,772.5 L46.02501,772.4 L46.12504,772.2 L46.22504,772.1 L46.42503,772.2 L46.52503,772.4 L46.72503,772.5 L46.82502,772.6 L47.02501,772.7 L47.22501,772.8 L47.42504,772.8 L47.62503,772.9 L47.82503,772.9 L48.02502,772.9 L48.22502,772.9 L48.42501,772.8 L48.62501,772.7 L48.82504,772.7 L49.02503,772.6 L49.12503,772.4 L49.32502,772.3 L49.42502,772.1 L49.52502,772 L49.62502,771.8 L49.72501,771.6 L49.82501,771.4 L49.82501,771.2 L49.82501,771 L49.82501,770.8 L49.82501,770.6 L49.82501,770.4 L49.72501,770.2 L49.62502,770 L49.52502,769.8 L49.32502,769.5 L49.22503,769.3 L49.02503,769.1 L48.82504,768.9 L48.62501,768.7 L48.42501,768.5 L48.22502,768.3 L48.12502,768.4 L47.92503,768.4 L47.72503,768.5 L47.42504,768.6 L47.12501,768.7 L46.72503,768.8 L46.22504,768.9 L46.22504,769.5 L46.22504,770.1 L46.22504,770.5 L46.22504,770.9 L46.22504,771.3 L46.22504,771.5 L46.22504,771.7 L46.22504,771.9 L46.22504,772 L46.22504,772.1'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.82504,727.2 L44.82504,727.1 L44.82504,726.9 L44.92504,726.8 L44.92504,726.6 L45.02504,726.5001 L45.12503,726.4 L45.32503,726.2 L45.42502,726.1 L45.62502,726.0001 L45.72501,725.9 L45.92501,725.9 L46.12504,725.8 L46.22504,725.8 L46.42503,725.8 L46.62503,725.9 L46.82502,725.9 L46.92502,726.0001 L47.12501,726.1 L47.22501,726.2 L47.325,726.3 L47.42504,726.4 L47.52504,726.5001 L47.62503,726.7 L47.72503,726.8 L47.72503,727.0001 L47.72503,727.1 L47.72503,727.2 L47.72503,727.4 L47.72503,727.5 L47.62503,727.7 L47.52504,727.8'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.325,732.4 L47.42504,732.3 L47.42504,756.9 L47.42504,757 L47.325,757.1 L47.325,757.2 L47.22501,757.3 L47.22501,757.4'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.52504,728 L47.52504,727.2 L47.52504,727.1 L47.52504,727.0001 L47.52504,726.9 L47.42504,726.7 L47.325,726.6 L47.22501,726.5001 L47.12501,726.4 L47.02501,726.3 L46.92502,726.2 L46.72503,726.1 L46.62503,726.1 L46.42503,726.1 L46.22504,726.1 L46.12504,726.1 L45.92501,726.1 L45.82501,726.1 L45.62502,726.2 L45.52502,726.3 L45.32503,726.4 L45.22503,726.5001 L45.12503,726.6 L45.02504,726.7 L45.02504,726.9 L44.92504,727.0001 L44.92504,727.1 L44.92504,727.2 L44.92504,728'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.52504,730.9 L47.22501,730.4'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.22502,768.3 L47.02501,762.9 L46.92502,762.8 L46.92502,762.7 L46.82502,762.6 L46.72503,762.5 L46.62503,762.4 L46.52503,762.4 L46.42503,762.3 L46.22504,762.3 L46.12504,762.3 L46.02501,762.4 L45.92501,762.4 L45.82501,762.5 L45.72501,762.6 L45.62502,762.7 L45.52502,762.8 L45.52502,762.9 L44.32502,768.3 L44.42501,768.4 L44.62501,768.4 L44.82504,768.5 L45.02504,768.6 L45.42502,768.7 L45.82501,768.8 L46.22504,768.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.92504,729.7 L44.92504,730.9 L44.92504,731.1 L44.82504,731.2 L44.82504,731.4 L44.82504,731.5 L44.82504,731.7 L44.82504,731.8 L44.92504,732 L44.92504,732.1 L45.02504,732.3 L45.12503,732.4 L45.22503,732.4'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.32503,730.4 L45.32503,730.5 L45.32503,730.6 L45.12503,730.7 L45.02504,730.8 L44.92504,730.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.72503,731.5 L47.72503,731.4 L47.72503,731.3 L47.72503,731.1 L47.82503,731 L47.82503,730.8 L47.92503,730.6 L47.92503,730.4 L47.92503,730.2 L47.92503,730.1 L47.92503,730 L47.92503,729.9 L47.92503,729.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.82504,731.1 L44.82504,731.5'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.325,733.3 L47.22501,731.1'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.32503,731.1 L45.22503,733.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.22501,729.7 L47.22501,732.1 L47.22501,732.2 L47.12501,732.2 L47.02501,732.2 L46.82502,732.2 L46.72503,732.2 L46.62503,732.2 L46.52503,732.1 L46.42503,732.1 L46.22504,732.1 L46.02501,732.1 L45.92501,732.1 L45.82501,732.2 L45.72501,732.2 L45.62502,732.2 L45.52502,732.2 L45.42502,732.2 L45.32503,732.2 L45.32503,732.1 L45.32503,729.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.22501,763.8 L47.22501,733.7 L47.22501,733.5001 L47.325,733.4 L47.325,733.3 L47.325,733.2 L47.22501,733.0001 L47.22501,732.9 L47.12501,732.8 L47.02501,732.7 L46.92502,732.6 L46.82502,732.5001 L46.72503,732.5001 L46.52503,732.4 L46.42503,732.4 L46.22504,732.4 L46.12504,732.4 L45.92501,732.4 L45.82501,732.5001 L45.72501,732.5001 L45.62502,732.6 L45.52502,732.7 L45.42502,732.8 L45.32503,732.9 L45.22503,733.0001 L45.22503,733.2 L45.22503,733.3 L45.22503,733.4 L45.22503,733.5001 L45.32503,733.7 L45.32503,763.8'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.22503,765.3 L50.02504,765.3 L50.02504,765.2 L50.12504,765.2 L50.12504,758.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M41.12503,697.5 L41.12503,697.3 L41.62502,697.3 L41.62502,697.5'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.72503,731.1 L47.22501,730.5'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M47.42504,732.3 L47.52504,732.1 L47.62503,732 L47.72503,731.8 L47.72503,731.7 L47.72503,731.5 L47.72503,731.4 L47.72503,731.2 L47.62503,731.1 L47.52504,730.9 L47.52504,729.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.32503,757.4 L45.22503,757.2 L45.12503,757.1 L45.12503,757 L45.12503,756.9 L45.12503,732.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.92504,727.8 L44.92504,727.7 L44.82504,727.5 L44.82504,727.4 L44.82504,727.2 L44.82504,727.1 L44.82504,727.0001 L44.82504,726.8 L44.92504,726.7 L44.92504,726.5001 L45.02504,726.4 L45.12503,726.3 L45.32503,726.2 L45.42502,726.1 L45.62502,726.1 L45.72501,726.0001 L45.92501,726.0001 L46.12504,725.9 L46.22504,725.9 L46.42503,725.9 L46.62503,726.0001 L46.82502,726.0001 L46.92502,726.1 L47.12501,726.1 L47.22501,726.2 L47.325,726.4 L47.42504,726.5001 L47.52504,726.6 L47.62503,726.8 L47.72503,726.9 L47.72503,727.1 L47.72503,727.2'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M51.42504,697.5 L51.42504,697.3 L50.92501,697.3 L50.92501,697.5 L50.72502,697.5 L58.62502,697.5 L58.62502,697.6 L58.62502,697.7 L58.62502,697.8 L58.62502,697.9 L58.62502,701.8 L58.62502,701.9 L58.62502,702 L58.62502,702.1 L58.62502,702.2 L51.52504,702.2 L51.42504,702.2 L51.12501,702.2 L50.92501,702.2 L50.72502,702.2 L50.72502,701.5 L50.62502,701.5 L50.62502,698.2 L50.72502,698.2 L50.72502,697.5'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.82504,693.2 L44.82504,693.1 L44.92504,693.1 L45.02504,693.0001 L45.12503,693.0001 L45.22503,693.1 L45.32503,693.1 L45.32503,693.2 L45.32503,693.1 L45.22503,693.1 L45.12503,693.0001 L45.02504,693.0001 L44.92504,693.1 L44.82504,693.1 L44.82504,693.2 L44.72501,693.2 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M41.62502,702.2 L41.62502,702.4 L41.12503,702.4 L41.12503,702.2'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.82504,693.6 L44.72501,693.5001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.82503,823.8 L48.72504,823.8'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.62501,714.6 L48.72504,714.1'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.92504,711.9 L48.62501,710.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.32502,711.8 L44.12502,710.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.22502,713.1 L48.42501,714.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.52501,783.3 L48.82504,781.8'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.02502,779.5 L43.72504,781.0001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.12503,756.6 L43.02502,756.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.82504,772.7 L49.22503,781.0001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.32501,781.0001 L43.72504,772.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.02502,772 L42.52503,781.0001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.62502,758.6 L50.42503,758.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.92502,757.6 L42.32504,757.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M40.02503,724.6 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.02503,823.6 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.42501,781.0001 L43.42501,777.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.02503,777.9 L49.02503,781.0001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.32504,758.6 L42.92502,758.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.42503,757.6 L49.62502,757.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.02504,781.0001 L49.52502,772'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.42502,756.6 L47.42504,756.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.72504,781.8 L44.02502,783.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.82503,782.3 L43.82503,823.5'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.82504,781.0001 L48.52501,779.5'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.82503,714.1 L43.92503,714.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.42501,710.3 L48.22502,711.8'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.12502,714.6 L44.32502,713.1'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.72504,823.5 L48.72504,782.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.22503,725.9 L49.22503,728'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.22503,729.7 L49.22503,756.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M49.22503,759.6 L49.22503,767.5001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.22501,725.9 L43.22501,728'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.22501,729.7 L43.22501,756.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M43.22501,759.6 L43.22501,767.5001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.52501,759.6 L44.52501,760.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.52501,762.7 L44.52501,767.5001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.02502,806.9 L48.02502,783.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.02502,779.5 L48.02502,772.9'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.02502,767.5001 L48.02502,762.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.02502,760.9 L48.02502,759.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.02502,756.6 L48.02502,729.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.42501,713.1 L44.42501,723.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.12502,688.7 L48.42501,688.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.42501,708.6 L47.92503,708.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.52501,708.6 L44.12502,708.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.12502,716.3 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.52501,716.3 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M44.12502,688.4 L44.12502,708.4'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.12504,725.3 L50.12504,728'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.12504,729.7 L50.12504,757.6'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.42501,688.4 L48.42501,708.4'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.42503,757.6 L42.42503,729.7'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M42.42503,728 L42.42503,725.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M45.82501,729.5 L46.62503,729.5'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M48.02502,726.8 L47.72503,727.0001'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M50.72502,698.2 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M41.82501,698.2 z'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M41.42503,702.4 L41.42503,702.2'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M51.12501,702.4 L51.12501,702.2'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M51.12501,697.5 L51.12501,697.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
      <path
        d='M41.42503,697.5 L41.42503,697.3'
        stroke='#000000'
        stroke-width='0.24'
        fill-opacity='0'
      />
    </g>
  );
};



// WEBPACK FOOTER //
// ./src/components/App/svg/double_docker_unit.js